<template>
  <van-popup style="width: 80%" round  v-model="show">
    <div class="content">
      <h3 class="title">拒绝退款</h3>
      <template v-if="refundParames.refundStatus == 0">
        <div class="input-box">
          <van-field 
            v-model="reasonsRejection" 
            type="textarea" 
            autosize 
            rows="1" 
            placeholder="请输入拒绝退款理由" 
          />
        </div>
        <div class="btn-box">
          <div class="btn-item secondary" @click="close">取消</div>
          <div class="btn-item" @click="consent">提交</div>
        </div>
      </template>
      <template v-else>
        <div class="text">{{refundParames.reasonsRejection}}</div>
        <div class="btn-box btn-secondary">
          <div class="btn-item" @click="close">关闭</div>
        </div>
      </template>
    </div>
  </van-popup>
</template>

<script>
export default {
  props: {
    showRefundPop: {
      type: Boolean,
      default: false
    },
    refundParames: {
      type: Object,
      default(){
        return {}
      }
    }
  },
  computed: {
    show: {
      get() {
        return this.showRefundPop
      },
      set(newVal) {
        this.$emit('update:showRefundPop',newVal)
      }
    }
  },
  data() {
    return {
      reasonsRejection: ''
    }
  },
  methods: {
    close() {
      this.show = false
      this.reasonsRejection = ''
    },
    consent() {
      if (!this.reasonsRejection) {
        this.$toast('请输入拒绝退款理由')
      }else {
        let parames = {
          reasonsRejection: this.reasonsRejection,
          orderNo: this.refundParames.orderNo
        }
        this.$api.customerList.rejectRefund(parames)
          .then(res => {
             if (res.success) {
              this.$emit('rejectRefund')
              this.close()
             }
          })
      }
    },
  }
}
</script>

<style lang="stylus" scoped>
  .content {
    padding: 10px 20px;
    .title {
      color: #333333;
      margin: 10px 0 0 0px;
      text-align: center;
    }
    .input-box {
      margin: 20px 0;
      >>> .van-field {
        padding: 10px;
        border-bottom: 1px solid #E5E5E5;
      }
    }
    .btn-box {
      display: flex;
      justify-content: space-between;
      .btn-item {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 120px;
        height: 36px;
        color: #FFFFFF;
        font-size: 17px;
        background: linear-gradient( 180deg, #FF8820 0%, #FF6B31 100%);
        border-radius: 4px;
        margin: 10px 10px;
      }
      .secondary {
        color: #333;
        background: #E5E5E5;
      }
    }
    .text {
      color: #333333;
      font-size: 15px;
      line-height: 26px;
      margin: 20px 0;
    }
    .btn-secondary {
      justify-content: center;
    }
  }
</style>